import { z, ZodType } from 'zod'

import { adUnitsAttributesSchema } from 'features/inventory/domain/components/ProductAdUnitsTable'
import { Domain } from 'features/inventory/types/domain'

export const unfilledRecoveryEnabled: ZodType<boolean> = z.boolean()
export const cacheAndReusePrebidBids: ZodType<boolean> = z.boolean()

export const schema = z
  .object({
    baseAdUnitPath: z.string().optional(),
    cacheAndReusePrebidBids,
    domainId: z.string(),
    unfilledRecoveryEnabled,
  })
  .extend(adUnitsAttributesSchema.shape)

export type Schema = z.infer<typeof schema>

export const schemaDefault = ({
  domainUnfilledRecovery: { baseAdUnitPath, cacheAndReusePrebidBids },
  id,
  unfilledRecoveryEnabled,
}: Domain): Schema => ({
  adUnitsAttributes: {},
  baseAdUnitPath,
  cacheAndReusePrebidBids,
  domainId: id,
  unfilledRecoveryEnabled,
})
